import React from "react";
import { Link } from "react-router-dom";

export default function ListingPolicy() {
    return (
        <div data-testid="listing-policy-page" className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
            <div className="mb-8">
                <span className="text-xs font-bold uppercase tracking-[0.2em] text-primary">Our approach</span>
                <h1 className="font-display font-black text-4xl sm:text-5xl tracking-tight mt-2">Who gets listed on Blackrod Now</h1>
                <p className="mt-2 text-sm text-muted-foreground">
                    Blackrod Now exists for the betterment of the people of Blackrod — helping residents find
                    activities, volunteering and community life in Blackrod and the local area.
                </p>
            </div>

            <div className="space-y-8 rounded-3xl border border-border bg-surface p-6 sm:p-8 text-sm leading-7">
                <Section title="The activity-first rule">
                    <p>
                        Organisations are listed for what they <b>run</b>, not what they <b>sell</b>. If you run
                        activities that residents can join, attend or take part in, you belong on Blackrod Now.
                    </p>
                    <ul className="list-disc pl-6 mt-3 space-y-2">
                        <li>Community groups, clubs, charities, schools, faith groups, youth groups and sports clubs get a full directory profile.</li>
                        <li>Volunteering roles with local organisations are listed on the volunteering pages.</li>
                        <li>Hireable venues are listed factually — capacity, cost and contact — as a resource for residents.</li>
                    </ul>
                </Section>

                <Section title="Businesses that host activities">
                    <p>
                        Some local businesses run genuine activities — a pub hosting a kids' Halloween party, a
                        café running a craft morning. Those <b>activities are welcome</b> in the events calendar,
                        including paid ones.
                    </p>
                    <ul className="list-disc pl-6 mt-3 space-y-2">
                        <li>The event appears in the calendar with a "Hosted by" line naming the business.</li>
                        <li>Businesses do not appear in the organisations directory, cannot be followed and cannot post feed updates.</li>
                        <li>An activity host's page is only visible while it has upcoming activities listed.</li>
                    </ul>
                    <p className="mt-3">
                        Blackrod Now is not a business directory and does not carry business promotion.
                    </p>
                </Section>

                <Section title="What counts as an activity">
                    <p>Every submission is reviewed by the Blackrod Now team using a simple test:</p>
                    <ul className="list-disc pl-6 mt-3 space-y-2">
                        <li><b>Listed:</b> events and sessions people attend or take part in — workshops, kids' parties, quizzes, classes, fun runs, live music nights. Paid or free.</li>
                        <li><b>Not listed:</b> offers, discounts, promotions, opening announcements, menu launches or anything whose purpose is to advertise a product or service.</li>
                    </ul>
                </Section>

                <Section title="Questions or appeals">
                    <p>
                        If your listing was declined and you think the activity-first test was misapplied,{" "}
                        <Link to="/contact" className="text-primary font-semibold hover:underline">contact us</Link>{" "}
                        — decisions are made against this published policy, and we're happy to look again.
                    </p>
                </Section>
            </div>
        </div>
    );
}

function Section({ title, children }) {
    return (
        <section>
            <h2 className="font-display font-bold text-lg mb-2">{title}</h2>
            {children}
        </section>
    );
}
